import { Component, OnInit, ViewEncapsulation } from '@angular/core';

@Component({
  selector: 'app-amenities-management',
  templateUrl: './amenities-management.component.html',
  styleUrls: ['./amenities-management.component.css'],
  encapsulation: ViewEncapsulation.None
})
export class AmenitiesManagementComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
